import previewForDonor from '@/services/api/previewForDonor';
import HttpStatus from 'http-status-codes';

export default {
    namespaced: true,
    state: {
        previewInfo: null,
        hasContent: null
    },
    getters: {
        getPreviewInfo: (state) => state.previewInfo,
        hasContent: (state) => state.hasContent
    },
    mutations: {
        setPreviewInfo (state, data) {
            state.previewInfo = data;
        },
        setHasContent (state, data) {
            state.hasContent = data;
        }
    },
    actions: {
        getPreviewInfo (context, id) {
            return previewForDonor.getPreviewInfo(id).then((data) => {
                context.commit('setHasContent', data.status === HttpStatus.OK);
                context.commit('setPreviewInfo', data.data.data);
            });
        },
        sendGreaterNeeds (context, data) {
            return previewForDonor.sendGreaterNeeds(data);
        }
    }
};
